<template>
    <div class="tablelist">
        <!--Se maneja el Header del componente de las tablas-->
        <div class="tableHeader">
            <!--Se maneja el botón para la creación de nuevos registros en Generic-Form-->
            <div class="tableHeaderButton">
                <button class="button-create-dea" @click="createButton">Nuevo</button>
            </div>
            <div class="tableHeaderPart">
                <!-- Menú desplegable para seleccionar el estado -->
                <div class="tableHeaderPager">
                    <va-select v-model="selectedStatus" :label="'Estado'" :options="perStateOptions" />
                </div>
                <!--Se maneja la paginación de la tabla-->
                <div class="tableHeaderPager">
                    <va-select v-model="perPage" :label="$t('tables.perPage')" :options="perPageOptions" />
                </div>
            </div>
        </div>
        <!--Se maneja la data de la tabla, y se imprime usando vuestic ui-->
        <va-data-table class="customTable" :fields="HeadTable" :data="filteredTableData" :per-page="parseInt(perPage)" no-data-label="No hay datos">
            <!--Se maneja la lógica para la columna de edición de registros-->
            <template slot="actionsFirst" slot-scope="props">
                <div v-for="item of fields[fields.length - 1].actionRef" :key="item.id" class="images_container">
                    <template>
                        <a @click="editCalendar(props.rowData)">
                            <img class="imgdata ma-0" :id="props.rowData.id" src="../../assets/images/edit.png" alt="Editar" title="Editar" width="25"/>
                        </a>
                    </template>
                </div>
            </template>
            <!--Se maneja la lógica para la columna de eliminación de registros-->
            <template slot="actionsSecond" slot-scope="props">
                <div v-for="item of fields[fields.length - 1].actionRef" :key="item.id" class="images_container">
                    <template>
                        <a @click="deleteCalendar(props.rowData)">
                            <img class="imgdata ma-0" :id="props.rowData.id" src="../../assets/images/inactive.png" alt="Eliminar" title="Eliminar" width="25"/>
                        </a>
                    </template>
                </div>
            </template>
            <!--Se maneja la lógica para la columna de visualización de registros-->
            <template slot="actionsThird" slot-scope="props">
                <div v-for="item of fields[fields.length - 1].actionRef" :key="item.id" class="images_container">
                    <template>
                        <a @click="detailCalendar(props.rowData)">
                            <img class="imgdata ma-0" :id="props.rowData.id" src="../../assets/images/detail.png" alt="openDet" title="OpenDet" width="25" />
                        </a>
                    </template>
                </div>
            </template>
        </va-data-table>
    </div>
</template>

<script>
export default {
  props: {
    InfoView: Array,
    HeadTable: Array,
  },
  data () {
    return {
      perPage: '20',
      perPageOptions: ['5', '10', '15', '20'],
      perStateOptions : ['activo', 'inactivo'],
      modalData: null,
      tableData: this.InfoView,
      selectedStatus: 'activo',
    }
  },
  computed: {
    //Retorna la data de la variable que contiene los títulos columnas
    fields () {
      return this.HeadTable
    },
    //Retorna la data que se imprime en la tabla, en lower case
    transformedTableData() {
        return this.InfoView.map(item => {
          const transformedItem = {}
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              // Reemplaza null con 0 si el valor es nulo
              const value = item[key] === null ? 0 : item[key];     
              // Convierte a minúsculas si es una cadena, de lo contrario, mantiene el valor
              transformedItem[key] = typeof value === 'string' ? value.toLowerCase() : value;
            }
          }
          return transformedItem;
        });
    },
    filteredTableData() {
        return this.transformedTableData.filter(item => item.staActive === this.selectedStatus);
    },
  },
  methods: {
    //Se ejecuta el emit del componente padre
    createButton(){
        this.$emit('callCreateModal');
    },
    //Actualiza la tabla
    updateTableData(newData) {
      this.tableData = newData;
    },
    //Envia un emit para editar cada registro
    editCalendar(data){
        this.$emit('editCalendar', data);
    },
    //Envía un emit para mostrar el detalle de cada registro
    detailCalendar(data){
        this.$emit('detailCalendar', data);
    },
    //Envía un emit para eliminar el registro
    deleteCalendar(data){
        this.$emit('deleteCalendar', data);
    }
  },
}
</script>

<style>


.tableHeaderPart{
    display: flex;
}

.tablelist .tableHeader{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 2rem;
    margin-top: 1.5rem;
}

.tablelist .tableHeader .tableHeaderPager{
    width: 150px;
    margin-left: 6rem;
}

.tablelist .va-select__label {
    color: #222;
}

.va-data-table__vuetable th {
    font-weight: 900;
    text-align: center; /* Alineación horizontal centrada */
}

.va-select__option--selected {
    color: #222;
}

.tablelist .va-button--small .va-button__content__title {
    color: #222;
}

.content table th {
    border-bottom: 2px solid #222;
    font-size: 12px;
}

.va-data-table__vuetable th.sortable {
    color: #222;
}

.imgdata {
    cursor: pointer;
    margin-left: 2px;
    margin-right: 2px;
}

.button-create-dea{
    background-color: rgb(255, 255, 255);
    border-color: rgb(34, 34, 34);
    border-radius: 4.8px;
    border-style: solid;
    font-size: 20px;
    height: 47px;
    width: 120px;
    cursor: pointer;

}
.button-create-dea:hover{
    background-color: #d0ab4b;
    color: white;
}

.images_container{
    display: flex;
    flex-direction: row;
}
</style>
